import React from "react";

export const OrderContext = React.createContext({});

export const OrderProvider = OrderContext.Provider;
